<div  class="modalCancel" >
  <div class="backArrowSection">
    <ion-icon (click)="goBack()" name="close-outline"></ion-icon>
  </div>

  <div class="title">{{'changeProfilePhoto' | translate}}</div>

  <div class="description-img" *ngIf="hasPhotoAtIndex0 && photoAtIndex0">
    <img [src]="photoAtIndex0" />
  </div>

  <span class="description" [innerHTML]="'selfieApprovalMessage' | translate">
  </span>
  <span class="description-difficulty">
    {{'havingDifficulty' | translate}}

  </span>
  <div style="border:1px solid var(--ion-color-white); display: flex; justify-content: center;">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button (click)="editPhoto()"  class="buttonShadow" expand="full" shape="round" fill="solid" color="primary">
            {{'editPicture' | translate}}
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button (click)="redoValidation()"  class="button-remake" expand="full" shape="round" fill="solid">
            {{'redoValidation' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>

    </ion-grid>

  </div>
</div>